import React, { useState, useEffect, useRef } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/publishers/addcahbackoffers.css";
import SideNav from "../../components/layout/sideNav";
import { useToast } from "../../context/toastContext";
import { useNavigate } from "react-router-dom";
import api from "../../services/apiClient";
import DOMPurify from "dompurify";
import DefaultImage from "../../assets/images/DefaultImage.png";

const AddCashbackOffersPage = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("PublisherInfo")) || {}
  );
  const [userAmount, setUserAmount] = useState("");
  const [referAmount, setreferAmount] = useState("");
  const [campInfo, setcampInfo] = useState({
    campaingID: "",
    payout: 0,
    goalName: "",
    campaignName: "",
    capsLeft: 0,
  });
  const [isCreatingLink, setisCreatingLink] = useState(false);
  const [isOfferSelectorActive, setisOfferSelectorActive] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [selectedCID, setSelectedCID] = useState(null);
  const debounceRef = useRef(null);

  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    if (userInfo?.cboAllowed) {
      setisOfferSelectorActive(true);
    }

    api
      .get(`/api/publisher/info`)
      .then((response) => {
        setUserInfo(response.data.data);
        localStorage.setItem(
          "PublisherInfo",
          JSON.stringify(response.data.data)
        );
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Login not found.",
        });
        navigate("/auth/login");
      });
  }, [navigate, showToast, userInfo?.cboAllowed, userInfo.payoutInfo.upiID]);

  const sanitizeInput = (value) => DOMPurify.sanitize(value);

  const handelUserAmountChange = (e) => {
    if (campInfo.payout - e.target.value - referAmount < 0) return;
    setUserAmount(sanitizeInput(e.target.value));
  };

  const handelReferAmountChange = (e) => {
    if (campInfo.payout - userAmount - e.target.value < 0) return;
    setreferAmount(sanitizeInput(e.target.value));
  };

  const handelCreateBtn = () => {
    if (isCreatingLink) return;
    setisCreatingLink(true);

    const userPay = sanitizeInput(userAmount);
    const referPay = sanitizeInput(referAmount);
    if (!campInfo.campaingID || !campInfo.campaignName || !campInfo.goalName) {
      showToast({
        status: "error",
        message: `Campaing Not Selected`,
      });
      setisCreatingLink(false);
      return;
    }

    if (!userPay) {
      document.getElementById("userAmount").focus();
      setisCreatingLink(false);
      return;
    }

    const goals = [
      {
        goalName: campInfo.goalName,
        cashbackAmount: Number(userPay),
        publisherProfit: Number(campInfo.payout - userPay - referPay),
        referAmount: Number(referPay),
      },
    ];

    api
      .post("/api/cashback-offer/create", {
        campaignId: campInfo.campaingID,
        goals,
      })
      .then((response) => {
        const fixedMessage = response.data.status
          ? "Created Successfully."
          : "Something went wrong.";
        showToast({
          status: response.data.status ? "success" : "error",
          message: response.data.message || fixedMessage,
        });
        setisCreatingLink(false);
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Something went wrong.",
        });
        setisCreatingLink(false);
      });
  };

  const handelSearchInpChnage = (e) => {
    const sText = sanitizeInput(e.target.value);
    setSearchText(sText);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    if (sText.length >= 3) {
      setIsSearching(true);

      debounceRef.current = setTimeout(() => {
        api
          .get(`/api/campaign/search?searchText=${sText}&filter=approved`)
          .then((response) => {
            if (response.data.status) {
              setSearchResults(response.data.campaigns);
            }
          })
          .catch((err) => {
            showToast({
              status: "error",
              message:
                err.response?.data?.message ||
                "Something went wrong while searching.",
            });
          })
          .finally(() => {
            setIsSearching(false);
          });
      }, 3000);
    }
  };

  const handelOfferSelectorConfirm = () => {
    if (!selectedCID) {
      showToast({
        status: "error",
        message: `Select any campaing to continue.`,
      });
      return;
    }
    let campaign = null;
    searchResults.forEach((result) => {
      if (result.campaignId === selectedCID) {
        campaign = result;
      }
    });
    const campaingID = campaign.campaignId;
    const campaignName = campaign.name;
    const goalName = campaign?.goals
      ?.filter((goal) => goal.isMain === true)
      ?.map((goal) => goal.goalName)
      ?.join(", ");
    const payout = campaign?.goals
      ?.filter((goal) => goal.isMain === true)
      ?.map((goal) => goal.value)
      ?.join(", ");
    const capsLeft = campaign.capsLeft;

    setcampInfo({
      campaignName,
      campaingID,
      goalName,
      payout,
      capsLeft,
    });

    setisOfferSelectorActive(false);
  };

  return (
    <div className="addcashbackoffer__page">
      <SideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
        campaignOpenInital={false}
        accManagerName={userInfo.adminInfo?.name}
        accManagerEmail={userInfo.adminInfo?.email}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>Cashback Offers - Create</h2>
            <p>Create cashback offers from here which helps you earn easily.</p>
          </div>
        </header>

        <header className="mobile-header">
          <div>
            <h2>Cashback Offers</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>

        {!userInfo?.cboAllowed ? (
          <div className="not-eligible">
            <Icon className="main" name="FaceFrown" />
            <h3>This account is not eligible to use this feature!</h3>
            <p>Only approved ones can use.</p>
          </div>
        ) : (
          <div className="main-container">
            <div className="offer-container">
              {campInfo?.campaingID ? (
                <div className="offer-info">
                  <img src={DefaultImage} alt="Offer pic" />
                  <div>
                    <span>{campInfo?.campaignName || "Loading..."}</span>
                    <span>
                      Only {campInfo?.capsLeft || "0"} caps available.
                    </span>
                  </div>
                </div>
              ) : (
                <div
                  className="no-offer"
                  onClick={() => setisOfferSelectorActive(true)}
                >
                  <Icon name="InformationCircle" />
                  <div>
                    <span>No Camp Selected</span>
                    <span>Tao here to open selction box</span>
                  </div>
                </div>
              )}
              <div className="payout-infos">
                <span>Goal: {campInfo.goalName || "Not Set"}</span>
                <span>Payout: ₹{campInfo.payout || "0"}</span>
                <span>
                  Profit: ₹
                  {campInfo?.payout
                    ? campInfo.payout - userAmount - referAmount
                    : "0"}
                </span>
              </div>
              <div className="inp-box">
                <label>User Amount</label>
                <input
                  type="number"
                  placeholder="Enter amount user will get for completing this goal"
                  autoComplete="off"
                  value={userAmount}
                  onChange={handelUserAmountChange}
                  id="userAmount"
                />
              </div>
              <div className="inp-box">
                <label>Refer Amount</label>
                <input
                  type="number"
                  placeholder="Enter refer amount for this goal."
                  autoComplete="off"
                  value={referAmount}
                  onChange={handelReferAmountChange}
                  id="referAmount"
                />
              </div>
              <button disabled={isCreatingLink} onClick={handelCreateBtn}>
                {isCreatingLink ? "Generating..." : "Generate Cashback Link"}
                {isCreatingLink ? (
                  <Icon name="ArrowPath" className="spin" />
                ) : (
                  <Icon name="Link" />
                )}
              </button>
            </div>
            <div className="infos-container">
              <div className="container">
                <h2>Terms & Conditions</h2>
                <p>
                  {"->"} Users must use fair practice to complete the offer.
                </p>
                <p>{"->"} One User (IP,GAID) get paid only once.</p>
                <p>
                  {"->"} Swift Digital Ads can block any particular user from participating
                  in others offers.
                </p>
                <p>
                  {"->"} Using fake ID’S for doing offers can lead to rejection.
                </p>
              </div>
              <div className="container">
                <h2>Cashback Offers Intro</h2>
                <p>
                  Using cashback offers section you can create a link to reward
                  your users whenever they complete a task Swift Digital Ads will pay them
                  and give your your profit in your wallet.
                </p>
              </div>
            </div>
          </div>
        )}
        <div
          className={`background-shadow above-side-nav ${isOfferSelectorActive ? "active" : ""
            }`}
        ></div>
        <div
          className={`offer-selector ${isOfferSelectorActive ? "active" : ""}`}
        >
          <div className="top">
            <div>
              <h3>Select Campaign</h3>
              <p>You can simply search and select.</p>
            </div>
            <div
              className="icon-container"
              onClick={() => setisOfferSelectorActive(false)}
            >
              <Icon name="XMark" />
            </div>
          </div>

          <div className="search-box">
            <Icon name="MagnifyingGlass" />
            <input
              type="text"
              placeholder="Search for campaigns by name eg: Swift Digital Ads"
              autoComplete="off"
              value={searchText}
              onChange={handelSearchInpChnage}
            />
          </div>
          {searchText.length >= 3 &&
            !isSearching &&
            searchResults &&
            searchResults.length > 0 &&
            searchResults.map((campaign) => {
              return (
                <div className="offer-s">
                  <div>
                    <span>{campaign.name}</span>
                    <span>{campaign.campaignId}</span>
                  </div>
                  <div
                    className={`select-box ${campaign.campaignId === selectedCID ? "selected" : ""
                      }`}
                    onClick={() =>
                      setSelectedCID(
                        campaign.campaignId === selectedCID
                          ? null
                          : campaign.campaignId
                      )
                    }
                  >
                    <Icon name="CheckDark" />
                  </div>
                </div>
              );
            })}

          {searchText.length >= 3 && isSearching ? (
            <div className="message">
              <Icon name="ArrowPath" className="spin" />
              <p>Lokking for campaings.</p>
            </div>
          ) : searchText.length === 0 ? (
            <div className="message">
              <Icon name="InformationCircle" />
              <p>Campaings will appear here.</p>
            </div>
          ) : searchText.length > 0 && searchText.length < 3 ? (
            <div className="message">
              <Icon name="InformationCircle" />
              <p>Enter atleast 3 charcaters to search.</p>
            </div>
          ) : searchText.length >= 3 && !searchResults && !isSearching ? (
            <div className="message">
              <Icon name="InformationCircle" />
              <p>No Campaing found.</p>
            </div>
          ) : (
            ""
          )}

          <div className="bottom">
            <button onClick={() => setisOfferSelectorActive(false)}>
              Close
            </button>
            <button onClick={handelOfferSelectorConfirm}>Confirm</button>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AddCashbackOffersPage;
